<app-loader *ngIf="isDisabled"></app-loader>
<div class="main-row">
    <button type="button" class="overlap-close-btn" (click)="close()">
        <i class="bi bi-x-lg"></i>
    </button>
    <!-- File Upload -->
    <div class="control-group">
        <span class="control-label">
            <i class="bi bi-file-earmark-arrow-up-fill"></i> Upload:
        </span>
        <div class="file-upload-wrapper" *ngIf="this.uploadfile == null">
            <input id="file-upload" type="file" style="display: none" (change)="handleFileInputChange($event)"
                accept=".xlsx,.xls,.csv">
            <label type="button" role="button" class="upload-btn" id="browseBtn" for="file-upload">
                <i class="bi bi-folder2-open"></i>
                Browse
            </label>
            <div class="formats">
                <span class="format-tag">.xlsx</span>
                <span class="format-tag">.xls</span>
                <span class="format-tag">.csv</span>
            </div>
        </div>
        <div id="fileStatus" class="file-status" *ngIf="this.uploadfile != null">
            <i class="fas fa-check-circle"></i>
            <span id="fileName">{{this.uploadfile.name}}</span>
            <button class="remove-btn" id="removeFile" (click)="removeFile()">
                <i class="bi bi-x-circle-fill"></i>
            </button>
        </div>
    </div>

    <!-- Sample Download -->
    <div class="control-group">
        <span class="control-label">
            <i class="bi bi-file-arrow-down-fill"></i> Sample:
        </span>
        <button type="button" class="sample-btn" id="downloadSampleBtn" (click)="downloadExcel()">
            <i class="bi bi-file-earmark-excel-fill"></i> Download
        </button>
    </div>

    <!-- Upload Action -->
    <button type="button" class="action-btn" id="uploadBtn" (click)="uploadfileData()"
        [disabled]="this.uploadfile == null || isDisabled">
        <i class="bi bi-upload" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Upload':'Loading...'}}
    </button>
</div>